import { init as init$1, getDefaultIntegrations as getDefaultIntegrations$1 } from '@sentry/browser';
import { applySdkMetadata } from '@sentry/core';
import { browserTracingIntegration } from './browserTracingIntegration.js';

// Tree-shakable guard to remove all code related to tracing

/**
 * Initialize the client side of the Sentry Astro SDK.
 *
 * @param options Configuration options for the SDK.
 */
function init(options) {
  const opts = {
    defaultIntegrations: getDefaultIntegrations(options),
    ...options,
  };

  applySdkMetadata(opts, 'astro', ['astro', 'browser']);

  return init$1(opts);
}

function getDefaultIntegrations(options) {
  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false",
  // in which case everything inside will get tree-shaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    return [...getDefaultIntegrations$1(options), browserTracingIntegration()];
  } else {
    return getDefaultIntegrations$1(options);
  }
}

export { init };
//# sourceMappingURL=sdk.js.map
